import axios from "axios";
import { REHYDRATE } from "redux-persist/constants";

export default function authentication(state = {}, action) {
    switch (action.type) {
        case "USER_DATA":
            return {
                ...state,
                user: action.payload
            };
        case REHYDRATE:
            const token = action.payload?.authentication?.loginToken;
            if (token) {
                axios.defaults.headers.Authorization = `Token ${token}`;
            }
            return state;
        case "LOGIN_SUCCESS":
            axios.defaults.headers.Authorization = `Token ${action.loginToken}`;

            return {
                ...state,
                loginToken: action.loginToken
            };
        case "LOGOUT":
            // Clear the Authorization header:
            delete axios.defaults.headers.Authorization;
            // Clear the state
            return {
                error: action.error || null
            };
    }
    return state;
}
